var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.22959C2.57272 7.92358 3.24699 8.52705 4 9.01959M4 9.01959C4.811 9.54874 5.71641 9.91656 6.66667 10.1029C7.5475 10.2722 8.4525 10.2722 9.33333 10.1029C10.2836 9.91656 11.189 9.54874 12 9.01959M4 9.01959L3 10.2296M14 7.22959C13.4273 7.92358 12.753 8.52705 12 9.01959M12 9.01959L13 10.2296M6.66667 10.1023L6.33333 11.5629M9.33333 10.1023L9.66667 11.5629",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/Hidden.a14c1f90edf0df6257b35bf62db86d8a.svg";
export { ForwardRef as ReactComponent };